// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:34:10.394Z
// Property: Fairforest Creekside (ID: 6767906449167634)
// Collections: 13 amenities, 2 floorplans (live), 22 photos, 49 POIs, 3 reviews, 5 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167634",
  "property_external_id": "1660079",
  "property_zillow_url": "https://www.zillow.com/apartments/greenville-sc/fairforest-creekside/Cgz9WR/",
  "property_apartments_url": "https://www.apartments.com/fairforest-creekside-greenville-sc/5jm4b5p/",
  "property_google_business_url": "https://www.google.com/maps/place/Fairforest+Creekside+-+a+Quinn+Residence/@34.801384,-82.343188,939m/data=!3m1!1e3!4m15!1m8!3m7!1s0x88582f7f0ffcf337:0x1b96752436b8b84f!2s16+Creekhill+St,+Greenville,+SC+29607!3b1!8m2!3d34.801384!4d-82.343188!16s%2Fg%2F11ks0322x_!3m5!1s0x88582fe3b1a3e3cd:0x19c2c45e20a17088!8m2!3d34.801384!4d-82.343188!16s%2Fg%2F11tmrdmb72?entry=ttu&g_ep=EgoyMDI2MDkyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57147875950",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fairforest-creekside",
  "property_name": "Fairforest Creekside",
  "property_website_url": "https://www.fairforestcreekside.com",
  "property_domain": "https://www.fairforestcreekside.com",
  "property_address": "16 Creekhill Street",
  "property_full_address": "16 Creekhill St, Greenville, SC 29607",
  "property_address_1": "16 Creekhill Street",
  "property_address_2": null,
  "property_address_city": "Greenville",
  "property_address_state": "SC",
  "property_address_zip_full": "29607",
  "property_address_zip": "29607",
  "property_address_country": "US",
  "property_address_county": "Greenville County",
  "property_neighborhood_address": "Pleasantburg",
  "property_address_latitude": "34.801384",
  "property_address_longitude": "-82.343188",
  "property_email": "FairforestCreekside.Reply.QuinnResidences@assist.rent",
  "property_phone": "(864) 383-9662",
  "property_call_tracking_phone": "864-383-9662",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "<p><strong>Modern townhome living with Greenville convenience.</strong> Explore spacious three-bedroom layouts with fenced backyards, smart-home technology, in-unit laundry, and polished finishes—then schedule your tour of Fairforest Creekside today.</p>",
  "property_long_description": "<p><strong>Modern townhome living with Greenville convenience.</strong> Fairforest Creekside gives you a fresh take on rental living, pairing spacious three-bedroom townhome-style layouts with the everyday ease of lawn maintenance, in-unit laundry, smart-home technology, and fenced backyards. Inside, your home feels polished and practical with stainless steel appliances, granite countertops, luxury flooring, and generous closet space.</p><p>Step outside and you have more room to enjoy the day, from the dog park and pickleball court to grill and fire pit areas designed for relaxed outdoor time. Explore available <a href=\"/floor-plans\">three-bedroom floor plans</a>, then get a closer look at the <a href=\"/amenities\">features and finishes</a> that make daily routines feel simple.</p><p>Set in Greenville’s Pleasantburg area, Fairforest Creekside keeps you close to local parks and trails, Conestee Nature Preserve, Haywood Mall, I-385 and I-85, with downtown Greenville, Falls Park on the Reedy, the Swamp Rabbit Trail, Fluor Field, and the Peace Center within easy reach.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-0576-728b-ba66-cc80049020a6.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
    "public_id": "01a188ea-0576-728b-ba66-cc80049020a6",
    "storage_key": "property/6767906449167634/01a188ea-0576-728b-ba66-cc80049020a6.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167634/01a0c014-c158-7320-81e3-34a0d19388e1.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c014-c158-7320-81e3-34a0d19388e1",
    "storage_key": "property/6767906449167634/01a0c014-c158-7320-81e3-34a0d19388e1.mp4",
    "thumbnail_key": "property/6767906449167634/01a0c014-c158-7320-81e3-34a0d19388e1_thumb.webp",
    "size_bytes": 32917735,
    "classification": "Community",
    "title": "Aerial Drone Footage of Modern Townhome Community",
    "description": "Experience a bird's-eye view of our beautiful townhome community, showcasing the modern architecture, landscaping, and streetscapes. Perfect for a property overview."
  },
  "property_total_units": "140",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "9",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, landscaping $55, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Pet screening is mandatory before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://fairforestcreekside.securecafe.com/onlineleasing/fairforest-creekside/floorplans.aspx",
  "property_resident_portal_url": "https://fairforestcreekside.securecafenet.com/residentservices/fairforest-creekside/userlogin",
  "property_apply_now_url": "https://fairforestcreekside.securecafe.com/onlineleasing/fairforest-creekside/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a0cf85-db59-77bf-86fe-c31431f8c964.webp",
  "property_primary_logo_media": {
    "alt_text": "Fairforest Creekside logo",
    "public_id": "01a0cf85-db59-77bf-86fe-c31431f8c964",
    "storage_key": "property/6767906449167634/01a0cf85-db59-77bf-86fe-c31431f8c964.webp",
    "width": 191,
    "height": 64
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a0cf86-d26f-7248-9d2f-c82f2368ee45.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0cf86-d26f-7248-9d2f-c82f2368ee45",
    "storage_key": "property/6767906449167634/01a0cf86-d26f-7248-9d2f-c82f2368ee45.webp",
    "width": 191,
    "height": 64
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a0cf86-c6c6-76e9-9d40-08ed055d463e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0cf86-c6c6-76e9-9d40-08ed055d463e",
    "storage_key": "property/6767906449167634/01a0cf86-c6c6-76e9-9d40-08ed055d463e.webp",
    "width": 191,
    "height": 64
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#5288c7",
  "property_secondary_color": "#586b48",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1503 - 1596",
  "property_sqft_min": "1503",
  "property_sqft_max": "1596",
  "property_price_range": "1733 - 2384",
  "property_price_min": "1986",
  "property_price_max": "2376",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/people/Fairforest-Creekside/100090364685159/",
  "property_instagram_url": "https://www.instagram.com/fairforestcreekside/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJzeOjseMvWIgRiHChIF7Ewhk",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Fairforest Creekside",
  "property_home_romance_title": "Embrace Life in Your Dream Townhome Community",
  "property_home_amenities_blurb": "<p><strong>Everyday comfort, elevated.</strong> Fairforest Creekside pairs polished townhome finishes with practical perks, including smart-home technology, in-home laundry, stainless steel appliances, granite countertops, luxury flooring, and spacious closets. Step outside to a backyard space of your own, enjoy weekends with lawn maintenance handled, and take advantage of pet-friendly conveniences like the dog park—plus concierge service for an added layer of support.</p>",
  "property_home_floorplans_blurb": "<p><strong>Two townhome layouts, one easy choice.</strong> Fairforest Creekside offers spacious three-bedroom floor plans in Greenville with two-story living, open gathering spaces, and thoughtful extras like flexible space, covered porches, generous closets, and select attached garages. Granite countertops, stainless steel appliances, luxury flooring, in-home laundry, and smart-home features add everyday polish from the moment you move in.</p>",
  "property_home_gallery_blurb": "<p><strong>See Fairforest Creekside in focus.</strong> Browse bright Greenville townhome interiors with light-toned flooring, connected living spaces, white cabinetry, dark countertops, and stainless steel finishes. Preview polished baths, generous closets, backyard access, and outdoor spots made for fresh-air downtime—then open the full gallery for a closer look.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Greenville energy, outdoor ease.</strong> Fairforest Creekside places you near the Laurens Road and Verdae corridor, close to Kitchen Sync, Stella’s Southern Brasserie, Holland Park, The Shops at Greenridge, and CU-ICAR. Greenlink stops plus quick access to I-85 and I-385 keep the city connected, while Conestee Nature Preserve, neighborhood trails, and downtown Greenville’s dining, arts, and riverfront scenery are all within easy reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about Fairforest Creekside.</strong> Reviews call out a responsive, professional team—from helpful leasing guidance to attentive maintenance—along with townhomes described as beautiful, spacious, well maintained, and a strong value in Greenville. Read the full reviews to see what the tour, leasing experience, and day-to-day support are like at Fairforest Creekside.</p>",
  "property_neighborhood_blurb": "<p><strong>Set your days between Greenville energy and easy outdoor escapes.</strong> From Fairforest Creekside, you’re close to the Laurens Road and Verdae corridor, where coffee runs, errands, and dinner plans come together around spots like Kitchen Sync, Stella’s Southern Brasserie, Holland Park, and The Shops at Greenridge. Nearby CU-ICAR adds an innovative edge to the area, while Greenlink stops and quick connections to I-85 and I-385 keep the rest of Greenville within reach.</p><p>When you want a change of pace, follow the map to neighborhood trails, Conestee Nature Preserve, or downtown’s dining, arts, and riverfront scenery. Explore what surrounds you, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Fairforest Creekside fits into the rhythm of the area.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Comfort starts with the details you use every day.</strong> At Fairforest Creekside, amenities are chosen to make your Greenville townhome feel polished, practical, and easy to settle into—from smart-home technology and in-home laundry to stainless steel appliances, granite countertops, luxury flooring, and spacious closets that help keep your routine organized.</p><p>Outside, your private backyard gives you extra room to unwind, while lawn maintenance helps keep weekends open for what you would rather do. Pet-friendly perks, including a dog park, add more convenience close to home, and concierge service brings an added layer of support when you need it. Browse the <a href=\"/gallery\">photo gallery</a> to see the finishes up close, then compare <a href=\"/floor-plans\">available floor plans</a> to find the layout that fits your day.</p>",
  "property_applynow_blurb": "<p><strong>Ready for modern townhome living?</strong> Fairforest Creekside brings together spacious three-bedroom layouts, polished finishes, smart-home convenience, in-unit laundry, lawn maintenance, and fenced backyards—all with Greenville access close at hand. Start your online application today and take the next step toward calling Fairforest Creekside home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Reach out to the Fairforest Creekside leasing team for help with townhome-style living in Greenville’s Pleasantburg area, from spacious three-bedroom layouts to the features that make daily routines feel simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Fairforest Creekside?</strong> Start here for quick answers about the community, leasing, and life in these brand-new, pet-friendly Greenville townhomes. Explore what to expect, from high-end finishes to smart-home conveniences—and if you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the three-bedroom townhome layout that fits how you live.</strong> Fairforest Creekside keeps the decision simple with two spacious floor plans in Greenville, each designed with two-story flow, open living space, and a smart blend of comfort and polish. Compare Churchill and Litchfield options side by side, then look for the details that matter most to your day: a flexible extra space, covered porch, generous closets, and, in select layouts, an attached one-car garage.</p><p>Inside, your home feels finished from the start with granite countertops, stainless steel appliances, luxury flooring, in-home laundry, and smart-home features that streamline daily routines. Explore current pricing and availability below, browse finishes in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you tour.</strong> The Fairforest Creekside photo gallery brings Greenville townhome living into focus, from bright open rooms with light-toned flooring to kitchens framed by white cabinetry, dark countertops, and stainless steel finishes. Notice how the main living spaces connect easily, how natural light moves through the windows, and how each room feels clean, current, and ready for your style.</p><p>As you browse, look for the moments that make the community feel complete: a backyard just beyond the door, polished bath finishes, generous closet space, and outdoor areas designed for fresh-air downtime. Then compare the images with available <a href=\"/floor-plans\">three-bedroom floor plans</a> or explore <a href=\"/virtual-tours\">virtual tours</a> for an even closer look.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Fairforest Creekside.</strong> Use the interactive map to find available brand-new townhomes in Greenville and see what surrounds this pet-friendly community, then picture a maintenance-free lifestyle with high-end finishes, smart-home features, and everyday peace of mind.</p>",
  "property_pets_blurb": "<p><strong>More room for paws, whiskers, and daily routines.</strong> At Fairforest Creekside, dogs and cats fit naturally into townhome living, with fenced backyards that make fresh-air breaks easier and spacious interiors that give pet beds, bowls, and toys a place of their own. Lawn maintenance keeps outdoor upkeep simple, while walking/biking trails, a pet play area, and future dog park plans add more ways to get outside close to home.</p><p>After a walk through Pleasantburg, come back to practical comforts like in-home laundry, durable luxury flooring, and smart-home features that help everyday life run smoothly. Explore the community’s <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Fairforest Creekside makes space for your pets, too.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Fairforest Creekside lifestyle.</strong><br>Love your brand-new townhome, high-end finishes, smart-home features, and maintenance-free peace of mind? Invite a friend to discover pet-friendly living in Greenville and help them find their own place to love coming home to.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Fairforest Creekside</strong><br>Log in to pay rent, submit maintenance requests, and manage your account with ease—part of the peace of mind and maintenance-free lifestyle that makes coming home to brand-new townhome living even better.</p>",
  "property_reviews_blurb": "<p><strong>See why Fairforest Creekside earns such enthusiastic reviews.</strong> Residents highlight the care, responsiveness, and professionalism they experience from the team—from Ashley’s patient guidance through leasing to Nicholis’s warm welcome and Seth’s attentive maintenance support.</p><p>You’ll also hear praise for the townhomes themselves: “absolutely beautiful,” well maintained, and designed with generous space that reviewers say delivers strong value. If you’re comparing options in Greenville, these firsthand stories offer a helpful look at what it’s like to tour, lease, and feel confident choosing Fairforest Creekside.</p>",
  "property_created_at": "1786373551442",
  "property_scheduletour_blurb": "<p><strong>See Fairforest Creekside in person.</strong> Tour brand-new, pet-friendly townhomes with high-end finishes, smart-home details, and the everyday ease of a maintenance-free lifestyle. From granite countertops to connected entry features, there’s more to appreciate up close. Schedule your tour today and picture life here.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Fairforest Creekside.</strong> Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture brand-new, pet-friendly townhome living with high-end finishes, smart-home features, and a maintenance-free lifestyle in Greenville. Welcome home.</p>",
  "property_virtualtours_blurb": "<p><strong>Step inside before you arrive.</strong> Fairforest Creekside’s virtual tours let you move through the spaces that matter most, from the 3BR, 2.5BA Townhouse and 3BR, 2.5BA Townhouse with Garage to the Churchill and Litchfield townhome tours. Follow the flow from open living areas to polished kitchens, then look closer at details like stainless steel appliances, stone-style countertops, luxury flooring, large closets, and in-home laundry.</p><p>Use each walkthrough to compare how the layouts feel in real time—where furniture could go, how the kitchen connects to the dining area, and which townhome-style features stand out. After you explore online, review current <a href=\"/floor-plans\">floor plan options</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Fairforest Creekside in Greenville in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Fairforest Creekside",
  "property_seo_title_home": "Fairforest Creekside |  Apartments in Greenville, SC",
  "property_seo_description_home": "Elevate your lifestyle at Fairforest Creekside in Greenville, SC. Enjoy luxury amenities, smart-home tech, and a dog park—all just steps from your door!",
  "property_seo_title_floorplans": "Floor Plans | Greenville, SC Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect space at Fairforest Creekside in Greenville, SC! Browse our unique three-bedroom floor plans designed for comfort and style—welcome home!",
  "property_seo_title_amenities": "Amenities | Greenville, SC Apartments for Rent",
  "property_seo_description_amenities": "Experience upscale living at Fairforest Creekside in Greenville, SC. Enjoy luxury amenities from a dog park to smart-home tech—your perfect apartment awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Greenville, SC",
  "property_seo_description_gallery": "Discover vibrant living at Fairforest Creekside, Greenville, SC, featuring spacious layouts, smart-home tech, and endless amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Fairforest Creekside Apartments",
  "property_seo_description_virtualtours": "Experience Fairforest Creekside in Greenville, SC! Take a virtual tour of our spacious three-bedroom apartments and see your next home come to life!",
  "property_seo_title_interactivemap": "Interactive Map | Fairforest Creekside Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Fairforest Creekside in Greenville, SC! Use our interactive map for apartment pricing, spacious layouts, and luxury amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Greenville, SC",
  "property_seo_description_neighborhood": "Discover local gems near Fairforest Creekside in Greenville, SC. Enjoy spacious three-bedroom apartments and a vibrant community!",
  "property_seo_title_contact": "Contact Us | Fairforest Creekside",
  "property_seo_description_contact": "Reach out to Fairforest Creekside in Greenville, SC! Our leasing team is ready to assist you with questions about our spacious three-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Greenville, SC",
  "property_seo_description_faqs": "Discover life at Fairforest Creekside, Greenville, SC! Explore spacious three-bedroom plans and luxury amenities in our FAQs.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Greenville, SC",
  "property_seo_description_reviews": "Read resident experiences at Fairforest Creekside in Greenville, SC! Enjoy luxury amenities like a dog park, pickleball court, and smart-home features.",
  "property_seo_title_applynow": "Apply Now | Apartments in Greenville, SC",
  "property_seo_description_applynow": "Discover luxury living at Fairforest Creekside, Greenville, SC! Enjoy three-bedroom plans, premier amenities, and a friendly community. Lease online now!",
  "property_seo_title_residentaccess": "Resident Access | Fairforest Creekside",
  "property_seo_description_residentaccess": "Unlock convenience at Fairforest Creekside! Log in to your resident portal for easy rent payments, maintenance requests, and community updates—right from home!",
  "property_seo_title_referafriend": "Refer A Friend | Fairforest Creekside",
  "property_seo_description_referafriend": "Refer a friend to Fairforest Creekside in Greenville, SC, and let great friendships blossom in our vibrant community. Share the joy of living here today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Fairforest Creekside",
  "property_seo_description_scheduletour": "Experience serene living at Fairforest Creekside in Greenville, SC. Schedule your tour today and find your perfect haven amidst tranquil landscapes!",
  "property_seo_title_privacy": "Privacy Policy | Fairforest Creekside",
  "property_seo_description_privacy": "Your privacy matters at Fairforest Creekside in Greenville, SC. Review our privacy policy to understand how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | Fairforest Creekside",
  "property_seo_description_accessibility": "At Fairforest Creekside in Greenville, SC, we prioritize digital inclusion. Our commitment ensures everyone can connect and thrive in our community.",
  "property_seo_title_sitemap": "Sitemap | Fairforest Creekside",
  "property_seo_description_sitemap": "Navigate Fairforest Creekside in Greenville, SC! Check out our sitemap to easily find your ideal home and discover the vibrant community that awaits you.",
  "property_seo_title_thankyou": "Thank You | Fairforest Creekside",
  "property_seo_description_thankyou": "Thank you for reaching out to Fairforest Creekside in Greenville, SC! Our team will connect with you soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Greenville, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793286808554",
  "amenities": [
    {
      "id": "custom_3a225dd2-e9f2-4b8a-aa5a-a55c9fc01e04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "125950774",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1507ea2-1de4-4c5d-820e-01ef0b9c3e88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120591077",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_765e72ca-042a-41a2-b408-d030dc2f1f8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120557474",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6738e04-3051-4850-aecc-b8beeec32fb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "129173143",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c35aca87-90e7-4f3e-8339-60dedaff1909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120591080",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1e2e98d7-6fa8-4d6b-b92e-6357b249cfc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "129173144",
      "title": "Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_851e9e4d-c392-4677-a139-baa0d2f31900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120557472",
      "title": "Smart-Home Technology",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ca866675-f07c-4c74-9aa2-524285f291b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "129173146",
      "title": "Grill Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5d82318-e2b4-4192-8a2b-f0ef214d30ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120557473",
      "title": "Private Backyard",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_62096d85-3af3-46a0-8d11-cf429602b4f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120591079",
      "title": "Concierge Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_32745ed5-4d89-41a7-bf8e-794dc6554b56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120591082",
      "title": "Luxury Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_838de0bf-8dfb-47fb-a59c-41979a0158ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "120591083",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6005fc00-2d57-4fa0-aa40-d6499b7d3cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "external_id": "129173136",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_d2c7bd3fa91e5d9a11873c5e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-0576-728b-ba66-cc80049020a6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a188ea-0576-728b-ba66-cc80049020a6",
        "storage_key": "property/6767906449167634/01a188ea-0576-728b-ba66-cc80049020a6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white shaker cabinets, beautiful granite countertops, a convenient island, and sleek stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a granite countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/19-web-or-mls-Creekhill%20St-S2410-015.jpg"
    },
    {
      "id": "ec_e75dd8cce5ae5d99e7e728b2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-1d26-743c-9f37-52ab0641119e.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily property with white siding and attached garages.",
        "public_id": "01a188ea-1d26-743c-9f37-52ab0641119e",
        "storage_key": "property/6767906449167634/01a188ea-1d26-743c-9f37-52ab0641119e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Showcasing the modern exterior of the multifamily property, featuring clean white siding, prominent garages, and inviting architectural details.",
      "link": "false",
      "alt_text": "A white house with a black roof and a car parked in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/4-web-or-mls-Creekhill%20St-S2410-004.jpg"
    },
    {
      "id": "ec_2791187bf148b9f10dff9412",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-1cc8-7219-a55e-05005f65cc3b.webp",
      "image_media": {
        "alt_text": "Dining room with a large wooden table and upholstered chairs, adjacent to a kitchen island with bar stools.",
        "public_id": "01a188ea-1cc8-7219-a55e-05005f65cc3b",
        "storage_key": "property/6767906449167634/01a188ea-1cc8-7219-a55e-05005f65cc3b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious dining area featuring a modern wooden table and comfortable seating, perfect for family meals and entertaining. The space seamlessly connects to the kitchen.",
      "link": "false",
      "alt_text": "A dining room with a wooden table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/15-web-or-mls-Creekhill%20St-S2410-011%20virtually%20staged.jpeg"
    },
    {
      "id": "ec_bb4b73ec27baf405ffe0f340",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-1d7d-74cd-a5e0-cad98687b056.webp",
      "image_media": {
        "alt_text": "Kitchen with granite island and stainless steel appliances",
        "public_id": "01a188ea-1d7d-74cd-a5e0-cad98687b056",
        "storage_key": "property/6767906449167634/01a188ea-1d7d-74cd-a5e0-cad98687b056.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a large granite island, stainless steel refrigerator, microwave, and stove. Includes ample cabinet space and a door leading to the exterior.",
      "link": "false",
      "alt_text": "A kitchen with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/18-web-or-mls-Creekhill%20St-S2410-014.jpg"
    },
    {
      "id": "ec_194cc2e279cd5c60a4335c82",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-1cf4-71e1-b751-2977cf3401f5.webp",
      "image_media": {
        "alt_text": "Kitchen island with sink and faucet, stainless steel refrigerator, and white cabinets.",
        "public_id": "01a188ea-1cf4-71e1-b751-2977cf3401f5",
        "storage_key": "property/6767906449167634/01a188ea-1cf4-71e1-b751-2977cf3401f5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a large granite island with a sink and faucet, stainless steel appliances including a refrigerator and microwave, and ample white cabinetry.",
      "link": "false",
      "alt_text": "A modern kitchen with a granite countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/17-web-or-mls-Creekhill%20St-S2410-013.jpg"
    },
    {
      "id": "ec_829060517ef24e04bb531f88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-1d40-71ab-9167-0f4d84c736af.webp",
      "image_media": {
        "alt_text": "Living room with white sofa and armchair, coffee table, and artwork.",
        "public_id": "01a188ea-1d40-71ab-9167-0f4d84c736af",
        "storage_key": "property/6767906449167634/01a188ea-1d40-71ab-9167-0f4d84c736af.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring comfortable seating, modern decor, and natural light.",
      "link": "false",
      "alt_text": "A living room with a white couch and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/7-web-or-mls-Creekhill%20St-S2410-005%20virtually%20staged.jpeg"
    },
    {
      "id": "ec_a4f2fa16a9eece8cd194e07e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-2af9-76bf-a14d-f6012b5b167e.webp",
      "image_media": {
        "alt_text": "A bedroom featuring a queen-size bed, nightstand, dresser with TV, and armchair.",
        "public_id": "01a188ea-2af9-76bf-a14d-f6012b5b167e",
        "storage_key": "property/6767906449167634/01a188ea-2af9-76bf-a14d-f6012b5b167e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, complete with a plush queen-size bed, elegant decor, and ample natural light.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/42-web-or-mls-Creekhill%20St-S2410-032%20virtually%20staged.jpeg"
    },
    {
      "id": "ec_c605693572a6791c02cc4776",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-31a3-76ca-ae5e-71f95e55357e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, white countertops, and a shower/tub combo.",
        "public_id": "01a188ea-31a3-76ca-ae5e-71f95e55357e",
        "storage_key": "property/6767906449167634/01a188ea-31a3-76ca-ae5e-71f95e55357e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a bright and spacious bathroom featuring a double vanity with ample counter space and a sleek shower/tub combination. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "A white bathroom with a sink, mirror, and bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/35-web-or-mls-Creekhill%20St-S2410-027.jpg"
    },
    {
      "id": "ec_536a9c09c7dfdbadc34cc0df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-2e6a-75ad-82a8-7a27b4eff728.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving",
        "public_id": "01a188ea-2e6a-75ad-82a8-7a27b4eff728",
        "storage_key": "property/6767906449167634/01a188ea-2e6a-75ad-82a8-7a27b4eff728.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with built-in wire shelving, ready for your personal touch.",
      "link": "false",
      "alt_text": "A white closet with a door and a shelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/26-web-or-mls-Creekhill%20St-S2410-022.jpg"
    },
    {
      "id": "ec_c6ac8001e99397556c0d9c02",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-2f3c-70c9-98dc-bc978c66fefb.webp",
      "image_media": {
        "alt_text": "Luxurious master bedroom with a king-size bed, modern nightstands, and artwork.",
        "public_id": "01a188ea-2f3c-70c9-98dc-bc978c66fefb",
        "storage_key": "property/6767906449167634/01a188ea-2f3c-70c9-98dc-bc978c66fefb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this elegantly appointed master bedroom, featuring a plush king-size bed and tasteful decor.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/29-web-or-mls-Creekhill%20St-S2410-023%20virtually%20staged.jpeg"
    },
    {
      "id": "ec_1f1719edf55313332177fb9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-2f80-718d-9e58-7117a446e0d3.webp",
      "image_media": {
        "alt_text": "Laundry room with washer and dryer.",
        "public_id": "01a188ea-2f80-718d-9e58-7117a446e0d3",
        "storage_key": "property/6767906449167634/01a188ea-2f80-718d-9e58-7117a446e0d3.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities featuring a washer and dryer for your convenience.",
      "link": "false",
      "alt_text": "A white laundry room with a washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/34-web-or-mls-Creekhill%20St-S2410-026.jpg"
    },
    {
      "id": "ec_1c3fd11d59bc532dc2d24e94",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-3c19-778c-8332-0cac383e0aed.webp",
      "image_media": {
        "alt_text": "Exterior of townhome with white siding and a fenced backyard.",
        "public_id": "01a188ea-3c19-778c-8332-0cac383e0aed",
        "storage_key": "property/6767906449167634/01a188ea-3c19-778c-8332-0cac383e0aed.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your private fenced backyard with a patio and storage unit, perfect for outdoor living and entertaining.",
      "link": "false",
      "alt_text": "A white house with a black fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/49-web-or-mls-Creekhill%20St-S2410-039.jpg"
    },
    {
      "id": "ec_c34c34bf8c74a75d1424841c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-3bb0-7448-a9ff-2fa3e2d68f63.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with white siding and fenced backyards.",
        "public_id": "01a188ea-3bb0-7448-a9ff-2fa3e2d68f63",
        "storage_key": "property/6767906449167634/01a188ea-3bb0-7448-a9ff-2fa3e2d68f63.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy your private fenced backyard with ample space for outdoor activities.",
      "link": "false",
      "alt_text": "A white building with black fencing and green grass in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/53-web-or-mls-Creekhill%20St-S2410-043.jpg"
    },
    {
      "id": "ec_c1bb6197c174d9880bce1543",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-3cde-73b8-80ec-0234ae4e3837.webp",
      "image_media": {
        "alt_text": "Private patio area with manicured lawn and white vinyl fencing, backing onto apartment buildings.",
        "public_id": "01a188ea-3cde-73b8-80ec-0234ae4e3837",
        "storage_key": "property/6767906449167634/01a188ea-3cde-73b8-80ec-0234ae4e3837.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy your own private outdoor space on the patio, complete with a lush green lawn and white vinyl fencing. Perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A white house with a grey door and a small garden.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/47-web-or-mls-Creekhill%20St-S2410-037.jpg"
    },
    {
      "id": "ec_354799009340cffcea86f87d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-3fe5-735b-bbf8-f9f8a6727838.webp",
      "image_media": {
        "alt_text": "Empty one-car garage with white walls and an automatic opener.",
        "public_id": "01a188ea-3fe5-735b-bbf8-f9f8a6727838",
        "storage_key": "property/6767906449167634/01a188ea-3fe5-735b-bbf8-f9f8a6727838.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This spacious, empty one-car garage offers convenience with its automatic opener, providing secure parking and additional storage space.",
      "link": "false",
      "alt_text": "A white room with a garage door in the middle.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/44-web-or-mls-Creekhill%20St-S2410-034.jpg"
    },
    {
      "id": "ec_a447246319547b19d88527ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-42c6-75ee-b823-ad4f3b7cef75.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with chairs, fire pit, grills, and pickleball courts in the background.",
        "public_id": "01a188ea-42c6-75ee-b823-ad4f3b7cef75",
        "storage_key": "property/6767906449167634/01a188ea-42c6-75ee-b823-ad4f3b7cef75.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax on the patio with comfortable seating, gather around the fire pit, or enjoy a barbecue with built-in grills. Adjacent pickleball courts offer fun for everyone.",
      "link": "false",
      "alt_text": "A wooden pergola over a patio with chairs and a fire pit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/60-web-or-mls-Creekhill%20St-2410-905.jpg"
    },
    {
      "id": "ec_e073a4575f6cfe04be86e15b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-4e76-71d0-82c5-6e7fd25cbd6c.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in grills and a picnic table.",
        "public_id": "01a188ea-4e76-71d0-82c5-6e7fd25cbd6c",
        "storage_key": "property/6767906449167634/01a188ea-4e76-71d0-82c5-6e7fd25cbd6c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy delicious meals outdoors at our community grilling area, complete with two state-of-the-art grills and comfortable picnic seating.",
      "link": "false",
      "alt_text": "Picnic table with two blue containers and a sign in front of a fence with trees in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/65-web-or-mls-Creekhill%20St-2410-910.jpg"
    },
    {
      "id": "ec_5a0ddfb3175aff9aa83e5c40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-4f31-77aa-b28f-a607abf844ba.webp",
      "image_media": {
        "alt_text": "Outdoor dog park with agility tunnel and turf.",
        "public_id": "01a188ea-4f31-77aa-b28f-a607abf844ba",
        "storage_key": "property/6767906449167634/01a188ea-4f31-77aa-b28f-a607abf844ba.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring lush turf and an agility tunnel for your furry friends to play and explore.",
      "link": "false",
      "alt_text": "A white building with a red flag in front of it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/61-web-or-mls-Creekhill%20St-2410-906.jpg"
    },
    {
      "id": "ec_a83bcdaaadc4f35e50f9c1ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-512f-7477-8f06-284a437fe021.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and covered seating area.",
        "public_id": "01a188ea-512f-7477-8f06-284a437fe021",
        "storage_key": "property/6767906449167634/01a188ea-512f-7477-8f06-284a437fe021.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Let your furry friends run and play in our dedicated dog park. Featuring agility equipment and a shaded seating area for owners.",
      "link": "false",
      "alt_text": "A park with a bench and a green canopy.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/63-web-or-mls-Creekhill%20St-2410-908.jpg"
    },
    {
      "id": "ec_f6b42ed77fc97a221e79c232",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-4fac-77d5-85e9-f8a218d40488.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, picnic table, and fence with townhomes in the background.",
        "public_id": "01a188ea-4fac-77d5-85e9-f8a218d40488",
        "storage_key": "property/6767906449167634/01a188ea-4fac-77d5-85e9-f8a218d40488.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our community dog park, complete with agility equipment and picnic areas. Perfect for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "A green field with a long blue bench and a black fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/62-web-or-mls-Creekhill%20St-2410-907.jpg"
    },
    {
      "id": "ec_744fe49f2e8e191ff4dd5ac9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-581b-77eb-a5ec-2749e0ac70cd.webp",
      "image_media": {
        "alt_text": "Backyard area with white fence and black metal fence surrounding a grassy area.",
        "public_id": "01a188ea-581b-77eb-a5ec-2749e0ac70cd",
        "storage_key": "property/6767906449167634/01a188ea-581b-77eb-a5ec-2749e0ac70cd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our spacious backyard, perfect for pets or relaxation.",
      "link": "false",
      "alt_text": "A white house with a black fence and green bushes in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/45-web-or-mls-Creekhill%20St-S2410-035.jpg"
    },
    {
      "id": "ec_e37c80f4fefd0895ab503afd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/01a188ea-61a8-74e9-a8c9-875f32acad64.webp",
      "image_media": {
        "alt_text": "Pickleball courts at a multifamily property.",
        "public_id": "01a188ea-61a8-74e9-a8c9-875f32acad64",
        "storage_key": "property/6767906449167634/01a188ea-61a8-74e9-a8c9-875f32acad64.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a game of pickleball on the on-site courts, perfect for staying active and social.",
      "link": "false",
      "alt_text": "A tennis court with a white building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/67-web-or-mls-Creekhill%20St-2410-912.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d0807b1f-ee62-4aa7-89e4-022e4f3bf3eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Stella's Southern Brasserie",
      "poi_type": "Restaurants",
      "poi_address": "340 Rocky Slope Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Charming place for locally sourced Southern European plates, coffee & breakfast, with patio seating.",
      "poi_long_description": "Charming place for locally sourced Southern European plates, coffee & breakfast, with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-18a9-74a9-8d8f-7251a511bd54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-18a9-74a9-8d8f-7251a511bd54",
        "storage_key": "property/6767906449167634/019fec2d-18a9-74a9-8d8f-7251a511bd54.webp",
        "width": 683,
        "height": 1024
      },
      "poi_business_url": "http://www.stellasbrasserie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4049061139460698748",
      "poi_item_slug": "stellas-southern-brasserie",
      "poi_latitude": "34.8289611",
      "poi_longitude": "-82.3306417",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 864-626-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwqzTxAvWIgRfLJkS6cnMTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_bfa3d369-cd98-4089-899e-c82ba0f29abf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Chestnut Coffee House + Market",
      "poi_type": "Restaurants",
      "poi_address": "325 Rocky Slope Rd #101, Greenville, SC 29607, USA",
      "poi_short_description": "Cozy cafe serving coffees, teas, pastries, and ice cream.",
      "poi_long_description": "Cozy cafe serving coffees, teas, pastries, and ice cream.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-1daa-76b9-ae68-9fa2457142c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-1daa-76b9-ae68-9fa2457142c0",
        "storage_key": "property/6767906449167634/019fec2d-1daa-76b9-ae68-9fa2457142c0.webp",
        "width": 740,
        "height": 914
      },
      "poi_business_url": "https://www.chestnutcoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12391826800132408818",
      "poi_item_slug": "chestnut-coffee-house--market",
      "poi_latitude": "34.8299882",
      "poi_longitude": "-82.33059279999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-63e4-730b-b48e-58a5816454cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2d-63e4-730b-b48e-58a5816454cb",
        "storage_key": "property/6767906449167634/019fec2d-63e4-730b-b48e-58a5816454cb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJZTjABMwvWIgR8sUO7NGc-Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_41097772-3b35-4d92-b779-08cc46804be5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "TakoSushi Verdae",
      "poi_type": "Restaurants",
      "poi_address": "325 Rocky Slope Rd Ste 108, Greenville, SC 29607, USA",
      "poi_short_description": "Casual joint with an eclectic menu including Mexican, Southwestern, Asian & sushi, in vibrant digs.",
      "poi_long_description": "Casual joint with an eclectic menu including Mexican, Southwestern, Asian & sushi, in vibrant digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-1fdf-716f-b56f-dfc20734b58a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-1fdf-716f-b56f-dfc20734b58a",
        "storage_key": "property/6767906449167634/019fec2d-1fdf-716f-b56f-dfc20734b58a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tako-sushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13541622467985938470",
      "poi_item_slug": "takosushi-verdae",
      "poi_latitude": "34.8297575",
      "poi_longitude": "-82.33050899999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 864-252-9094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUljPAAvWIgRJhjAVuOB7bs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_6bd6bf8b-2919-4f90-9efb-8fbc5477d909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Greenfield's Bagels & Deli-Midtown",
      "poi_type": "Restaurants",
      "poi_address": "101 Verdae Blvd #180, Greenville, SC 29607, USA",
      "poi_short_description": "Hot pastrami sandwiches, bagel sandwiches, plus corned beef and turkey on the deli menu.",
      "poi_long_description": "Hot pastrami sandwiches, bagel sandwiches, plus corned beef and turkey on the deli menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-1ec4-7778-9451-6f6574c64b71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-1ec4-7778-9451-6f6574c64b71",
        "storage_key": "property/6767906449167634/019fec2d-1ec4-7778-9451-6f6574c64b71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://greenfieldsbagelsanddeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17069858627597300316",
      "poi_item_slug": "greenfields-bagels--deli-midtown",
      "poi_latitude": "34.8212561",
      "poi_longitude": "-82.3411761",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 864-987-0064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZ8CwwwvWIgRXPISWPtR5Ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_4b3848cc-1e6b-404d-a7f6-5b09301af46f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Tropical Grille Verdae",
      "poi_type": "Restaurants",
      "poi_address": "1037 Verdae Blvd, Greenville, SC 29607, USA",
      "poi_short_description": "Casual eatery serving bowls, burgers, and other comfort food, including vegetarian options.",
      "poi_long_description": "Casual eatery serving bowls, burgers, and other comfort food, including vegetarian options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-1e0d-713f-bb22-c4e17bc7d6f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-1e0d-713f-bb22-c4e17bc7d6f7",
        "storage_key": "property/6767906449167634/019fec2d-1e0d-713f-bb22-c4e17bc7d6f7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.eattg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16744419620356215992",
      "poi_item_slug": "tropical-grille-verdae",
      "poi_latitude": "34.8352127",
      "poi_longitude": "-82.3171691",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 864-203-7188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZJvLC8vWIgRuNRp0e0gYOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1d990f02-51d5-4a2d-8159-410bc07ca0c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Firebirds Wood Fired Grill",
      "poi_type": "Restaurants",
      "poi_address": "1025 Woodruff Rd d115, Greenville, SC 29607, USA",
      "poi_short_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_long_description": "Chain restaurant serving steaks, seafood & cocktails in an upscale lodgelike setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-19a2-7308-adf1-de45f7523f34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-19a2-7308-adf1-de45f7523f34",
        "storage_key": "property/6767906449167634/019fec2d-19a2-7308-adf1-de45f7523f34.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://firebirdsrestaurants.com/greenville",
      "poi_directions_map_url": "https://maps.google.com/?cid=7249551862491393028",
      "poi_item_slug": "firebirds-wood-fired-grill",
      "poi_latitude": "34.8335925",
      "poi_longitude": "-82.3090513",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 864-704-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95K6BiwvWIgRBCySWAKVm2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b0ef5209-46d2-4fa6-99fc-ade65b0db8d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Bad Daddy's Burger Bar",
      "poi_type": "Restaurants",
      "poi_address": "1025 Woodruff Rd D-101, Greenville, SC 29607, USA",
      "poi_short_description": "Hip, buzzy chain serving creative burgers with gourmet toppings, plus hand-cut fries & other sides.",
      "poi_long_description": "Hip, buzzy chain serving creative burgers with gourmet toppings, plus hand-cut fries & other sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-1b9f-7469-acdf-279dbab8f073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-1b9f-7469-acdf-279dbab8f073",
        "storage_key": "property/6767906449167634/019fec2d-1b9f-7469-acdf-279dbab8f073.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.baddaddysburgerbar.com/locations/bad-daddys-burger-bar-greenville",
      "poi_directions_map_url": "https://maps.google.com/?cid=9563419563855731739",
      "poi_item_slug": "bad-daddys-burger-bar",
      "poi_latitude": "34.8330724",
      "poi_longitude": "-82.3084257",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 864-288-8161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95K6BiwvWIgRG1yklWwXuIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_3775db2d-360c-46f3-9285-f546aa848987",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "First Watch",
      "poi_type": "Restaurants",
      "poi_address": "1125 Woodruff Rd #1702, Greenville, SC 29607, USA",
      "poi_short_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_long_description": "Cafe chain for health-minded breakfast, brunch & lunch options such as omelets, salads & soups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-1dab-7160-9253-363c6d5bf65e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-1dab-7160-9253-363c6d5bf65e",
        "storage_key": "property/6767906449167634/019fec2d-1dab-7160-9253-363c6d5bf65e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.firstwatch.com/locations/woodruff-road/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12896258154940589564",
      "poi_item_slug": "first-watch",
      "poi_latitude": "34.8270048",
      "poi_longitude": "-82.2986253",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 864-813-4054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqXdX8-cpWIgR_OX38Ha2-LI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_ca00a170-95f9-4845-a004-eb5f53f452d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Copper River Grill",
      "poi_type": "Restaurants",
      "poi_address": "775 Haywood Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Grill offering steaks & seafood, classic American fare & cocktails in a casual setting.",
      "poi_long_description": "Grill offering steaks & seafood, classic American fare & cocktails in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-21fa-720c-88be-de82a5e1471a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-21fa-720c-88be-de82a5e1471a",
        "storage_key": "property/6767906449167634/019fec2d-21fa-720c-88be-de82a5e1471a.webp",
        "width": 1280,
        "height": 968
      },
      "poi_business_url": "http://www.copperrivergrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=111940227322706232",
      "poi_item_slug": "copper-river-grill",
      "poi_latitude": "34.8526175",
      "poi_longitude": "-82.3362381",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 864-627-0041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9XBkbfAuWIgROHmlLQuxjQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_30da4604-12d5-441e-b056-8e662da4580c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Grill Marks - Haywood Mall",
      "poi_type": "Restaurants",
      "poi_address": "Haywood Mall, 700 Haywood Rd Ste 2023B, Greenville, SC 29607, USA",
      "poi_short_description": "Casual eatery serving Angus burgers, truffle fries and shakes at a mall location.",
      "poi_long_description": "Casual eatery serving Angus burgers, truffle fries and shakes at a mall location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-22fb-76d9-8d95-7f9af3b73459.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-22fb-76d9-8d95-7f9af3b73459",
        "storage_key": "property/6767906449167634/019fec2d-22fb-76d9-8d95-7f9af3b73459.webp",
        "width": 991,
        "height": 1280
      },
      "poi_business_url": "https://www.grillmarks.com/haywood-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=14270145159890700404",
      "poi_item_slug": "grill-marks---haywood-mall",
      "poi_latitude": "34.850884",
      "poi_longitude": "-82.3334369",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 864-288-5202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-81oR-UuWIgRdIiLnGq9CcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_ed625b1c-f807-46c2-bdb1-f2e45de35332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "CHRIST CHURCH EPISCOPAL SCHOOL",
      "poi_type": "Education",
      "poi_address": "245 Cavalier Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Private Episcopal day school for grades K–12 on Cavalier Drive.",
      "poi_long_description": "Private Episcopal day school for grades K–12 on Cavalier Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-2432-74bb-8cc1-5ddf9f7df756.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-2432-74bb-8cc1-5ddf9f7df756",
        "storage_key": "property/6767906449167634/019fec2d-2432-74bb-8cc1-5ddf9f7df756.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cces.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12457345962525067964",
      "poi_item_slug": "christ-church-episcopal-school",
      "poi_latitude": "34.7944658",
      "poi_longitude": "-82.3482423",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 864-299-1522",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78c9-77e7-8a22-3b8673f1cb20",
        "storage_key": "property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRXV26H4lWIgRvAp0rCZi4aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7847e521-6526-4bd4-8158-3ec8fe0f89c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Overbrook Child Development",
      "poi_type": "Education",
      "poi_address": "111 Laurens Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Greenville County Schools child development center offering pre-kindergarten programs on Laurens Road.",
      "poi_long_description": "Greenville County Schools child development center offering pre-kindergarten programs on Laurens Road.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.greenville.k12.sc.us/child/main.asp?titleid=overbrook",
      "poi_directions_map_url": "https://maps.google.com/?cid=10240996883707751480",
      "poi_item_slug": "overbrook-child-development",
      "poi_latitude": "34.8531477",
      "poi_longitude": "-82.3801419",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 864-355-7350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78c9-77e7-8a22-3b8673f1cb20",
        "storage_key": "property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN-dYBy8uWIgROGxIF2hUH44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_da710673-ec53-4b8f-8785-cc1fe5d4df7f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Dr. Phinnize J. Fisher Middle School",
      "poi_type": "Education",
      "poi_address": "700 Millennium Blvd, Greenville, SC 29607, USA",
      "poi_short_description": "Public middle school, Greenville County Schools.",
      "poi_long_description": "Public middle school, Greenville County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-25d8-75ad-8d71-a251a2263260.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-25d8-75ad-8d71-a251a2263260",
        "storage_key": "property/6767906449167634/019fec2d-25d8-75ad-8d71-a251a2263260.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://www.greenville.k12.sc.us/fisher/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13797375291443349187",
      "poi_item_slug": "dr-phinnize-j-fisher-middle-school",
      "poi_latitude": "34.8165912",
      "poi_longitude": "-82.3185503",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 864-452-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78c9-77e7-8a22-3b8673f1cb20",
        "storage_key": "property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ41icMUcvWIgRw4Y717kfer8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b9b83e30-bf6d-4261-97cd-c9adfd21e4c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Sara Collins Elementary School",
      "poi_type": "Education",
      "poi_address": "1200 Parkins Mill Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Public elementary school, Greenville County Schools.",
      "poi_long_description": "Public elementary school, Greenville County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-2696-75ee-a549-de140996ec5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-2696-75ee-a549-de140996ec5b",
        "storage_key": "property/6767906449167634/019fec2d-2696-75ee-a549-de140996ec5b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.greenville.k12.sc.us/scollins/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12157368891051629849",
      "poi_item_slug": "sara-collins-elementary-school",
      "poi_latitude": "34.8144104",
      "poi_longitude": "-82.36482459999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 864-355-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78c9-77e7-8a22-3b8673f1cb20",
        "storage_key": "property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYcZSZZMvWIgRGV2ECpimt6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_bc5acb6f-a796-44e2-9f09-4c6263403150",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "St. Joseph's Catholic School",
      "poi_type": "Education",
      "poi_address": "100 St. Joseph's Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Private Catholic school for grades 6–12.",
      "poi_long_description": "Private Catholic school for grades 6–12.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-2f2c-742f-ae03-87c12bd609f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-2f2c-742f-ae03-87c12bd609f7",
        "storage_key": "property/6767906449167634/019fec2d-2f2c-742f-ae03-87c12bd609f7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sjcatholicschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11452880786945597988",
      "poi_item_slug": "st-josephs-catholic-school",
      "poi_latitude": "34.8102499",
      "poi_longitude": "-82.3398666",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 864-234-9009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78c9-77e7-8a22-3b8673f1cb20",
        "storage_key": "property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEWcPMXEvWIgRJOLJUGXO8J4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_545de0b6-6f68-4200-a3e2-f9ab9a42fe0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Greenville Technical College",
      "poi_type": "Education",
      "poi_address": "506 S Pleasantburg Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Public two-year technical college on South Pleasantburg Drive.",
      "poi_long_description": "Public two-year technical college on South Pleasantburg Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-74a2-7213-b9a7-d9bafb901e71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-74a2-7213-b9a7-d9bafb901e71",
        "storage_key": "property/6767906449167634/019fec29-74a2-7213-b9a7-d9bafb901e71.webp",
        "width": 1200,
        "height": 754
      },
      "poi_business_url": "https://www.gvltec.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5078691404558523632",
      "poi_item_slug": "greenville-technical-college",
      "poi_latitude": "34.8270773",
      "poi_longitude": "-82.37362639999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 864-250-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78c9-77e7-8a22-3b8673f1cb20",
        "storage_key": "property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJccT0kcYvWIgR8FyKpOwie0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_49da43eb-c19f-49d6-8e3b-926176ca3161",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Regal Hollywood - Greenville",
      "poi_type": "Entertainment",
      "poi_address": "1029 Woodruff Rd N101, Greenville, SC 29607, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-2ae4-767e-b57d-f372c55e2ecb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-2ae4-767e-b57d-f372c55e2ecb",
        "storage_key": "property/6767906449167634/019fec2d-2ae4-767e-b57d-f372c55e2ecb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-hollywood-greenville-0488",
      "poi_directions_map_url": "https://maps.google.com/?cid=4206842748576852317",
      "poi_item_slug": "regal-hollywood---greenville",
      "poi_latitude": "34.8334609",
      "poi_longitude": "-82.304996",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-643f-711c-9edf-fd5b1c00de43.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2d-643f-711c-9edf-fd5b1c00de43",
        "storage_key": "property/6767906449167634/019fec2d-643f-711c-9edf-fd5b1c00de43.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJD7y5li4vWIgRXenZ5jC1YTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6f0fd3ca-6b54-40be-aa95-121aeb9b502f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Peace Center Concert Hall",
      "poi_type": "Entertainment",
      "poi_address": "300 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Touring musicians & resident theater troupes perform at this sizable, contemporary concert hall.",
      "poi_long_description": "Touring musicians & resident theater troupes perform at this sizable, contemporary concert hall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-29e9-717a-865f-7a66d7828913.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-29e9-717a-865f-7a66d7828913",
        "storage_key": "property/6767906449167634/019fec2d-29e9-717a-865f-7a66d7828913.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "http://www.peacecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17197284789852293874",
      "poi_item_slug": "peace-center-concert-hall",
      "poi_latitude": "34.8475621",
      "poi_longitude": "-82.40110709999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 864-467-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJodjBas0xWIgR8spfuGYHqe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1384797e-6d14-4ed7-a92a-db9b8f229b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Falls Park on the Reedy",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Picturesque park with waterfall views, a curved suspension bridge & many acres of gardens.",
      "poi_long_description": "Picturesque park with waterfall views, a curved suspension bridge & many acres of gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-5a55-7042-b2ae-71fd2255d7c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-5a55-7042-b2ae-71fd2255d7c1",
        "storage_key": "property/6767906449167634/019fec29-5a55-7042-b2ae-71fd2255d7c1.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.greenvillesc.gov/167/Falls-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=3467913960939550308",
      "poi_item_slug": "falls-park-on-the-reedy",
      "poi_latitude": "34.8449748",
      "poi_longitude": "-82.4015955",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-467-4350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b3-763b-adad-1e0ade6faada",
        "storage_key": "property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcTkL5TIwWIgRZHZrqV-BIDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a056474b-f68b-4582-bf12-c973b7e26339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "The Children’s Museum of the Upstate",
      "poi_type": "Entertainment",
      "poi_address": "300 College St, Greenville, SC 29601, USA",
      "poi_short_description": "Targeted at under-12 kids this large museum has multiple hands-on galleries plus camps & programs.",
      "poi_long_description": "Targeted at under-12 kids this large museum has multiple hands-on galleries plus camps & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-4bc9-75e9-a96c-43ee75f7eab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-4bc9-75e9-a96c-43ee75f7eab5",
        "storage_key": "property/6767906449167634/019fec29-4bc9-75e9-a96c-43ee75f7eab5.webp",
        "width": 1280,
        "height": 1056
      },
      "poi_business_url": "https://tcmupstate.org/greenville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11902694258438889280",
      "poi_item_slug": "the-childrens-museum-of-the-upstate",
      "poi_latitude": "34.8558685",
      "poi_longitude": "-82.4004377",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 864-233-7755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b6-73e3-8f41-dc9f119417e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b6-73e3-8f41-dc9f119417e7",
        "storage_key": "property/6767906449167634/019fec29-78b6-73e3-8f41-dc9f119417e7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJhQmL8c8xWIgRQN9UaF3dLqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_46bd6815-3230-4de7-9ad8-4c8422229e8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Roper Mountain Science Center",
      "poi_type": "Entertainment",
      "poi_address": "402 Roper Mountain Rd, Greenville, SC 29615, USA",
      "poi_short_description": "Variety of science attractions such as a planetarium, observatory, arboretum & living history farm.",
      "poi_long_description": "Variety of science attractions such as a planetarium, observatory, arboretum & living history farm.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-4cfa-71a3-853b-2bad1d05f3c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-4cfa-71a3-853b-2bad1d05f3c2",
        "storage_key": "property/6767906449167634/019fec29-4cfa-71a3-853b-2bad1d05f3c2.webp",
        "width": 820,
        "height": 462
      },
      "poi_business_url": "http://www.ropermountain.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7135754818501616955",
      "poi_item_slug": "roper-mountain-science-center",
      "poi_latitude": "34.839045",
      "poi_longitude": "-82.3092369",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 864-355-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b6-73e3-8f41-dc9f119417e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b6-73e3-8f41-dc9f119417e7",
        "storage_key": "property/6767906449167634/019fec29-78b6-73e3-8f41-dc9f119417e7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJO2ewONMuWIgROyUSWTNLB2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_987c8765-5a95-4fcd-878c-c73f90a36436",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Fluor Field",
      "poi_type": "Entertainment",
      "poi_address": "945 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Baseball stadium modeled after the Boston Red Sox's famed field, hosting minor-league ball games.",
      "poi_long_description": "Baseball stadium modeled after the Boston Red Sox's famed field, hosting minor-league ball games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-50de-72ca-82a8-84547eef565a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-50de-72ca-82a8-84547eef565a",
        "storage_key": "property/6767906449167634/019fec29-50de-72ca-82a8-84547eef565a.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "http://milb.com/greenville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13620242211676828064",
      "poi_item_slug": "fluor-field",
      "poi_latitude": "34.8421855",
      "poi_longitude": "-82.4081831",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 864-240-4528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-789f-71cb-a523-6f1fa8c5af30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-789f-71cb-a523-6f1fa8c5af30",
        "storage_key": "property/6767906449167634/019fec29-789f-71cb-a523-6f1fa8c5af30.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo7Q8sTUwWIgRoDHH3SDSBL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f8dd70bf-dfa3-43db-b811-33cde84d24ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Prisma Health Greenville Memorial Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "701 Grove Rd, Greenville, SC 29605, USA",
      "poi_short_description": "Full-service hospital on Grove Road, the flagship of the Prisma Health Upstate system.",
      "poi_long_description": "Full-service hospital on Grove Road, the flagship of the Prisma Health Upstate system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-56d4-768c-bdc3-13a4d09b7990.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-56d4-768c-bdc3-13a4d09b7990",
        "storage_key": "property/6767906449167634/019fec29-56d4-768c-bdc3-13a4d09b7990.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://prismahealth.org/locations/hospitals/greenville-memorial-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=5598622282899715788",
      "poi_item_slug": "prisma-health-greenville-memorial-hospital",
      "poi_latitude": "34.8187964",
      "poi_longitude": "-82.41293329999999",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 864-455-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78cd-701b-89d7-dd4b2674b320.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78cd-701b-89d7-dd4b2674b320",
        "storage_key": "property/6767906449167634/019fec29-78cd-701b-89d7-dd4b2674b320.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_Tqq2swWIgRzPbSs01Nsk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_84f1b24b-9660-4ff2-85eb-2dd1a905e604",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Prisma Health Urgent Care-Verdae",
      "poi_type": "Health and Wellness",
      "poi_address": "905 Verdae Blvd Ste 101, Greenville, SC 29607, USA",
      "poi_short_description": "Walk-in urgent care clinic in the Verdae district, part of the Prisma Health system.",
      "poi_long_description": "Walk-in urgent care clinic in the Verdae district, part of the Prisma Health system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-2b4a-7604-9113-dce2d0d1b331.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-2b4a-7604-9113-dce2d0d1b331",
        "storage_key": "property/6767906449167634/019fec2d-2b4a-7604-9113-dce2d0d1b331.webp",
        "width": 1200,
        "height": 674
      },
      "poi_business_url": "https://www.prismahealthurgentcare.org/locations/greenville-verdae-sc?location=3001&utm_source=rioseo&utm_medium=local&utm_content=clinic_link_3001",
      "poi_directions_map_url": "https://maps.google.com/?cid=1336354858611842888",
      "poi_item_slug": "prisma-health-urgent-care-verdae",
      "poi_latitude": "34.8318088",
      "poi_longitude": "-82.317646",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 864-990-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9GyvyYvWIgRSB9t4amvixI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_ffb1662f-3f9b-449b-9796-113f9e0fe95d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "2210 Laurens Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-3262-77c5-94c1-1a7ca88fc7be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-3262-77c5-94c1-1a7ca88fc7be",
        "storage_key": "property/6767906449167634/019fec2d-3262-77c5-94c1-1a7ca88fc7be.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cvs.com/store-locator/greenville-sc-pharmacies/2210-laurens-road-greenville-sc-29607/storeid=2246?WT.mc_id=LS_GOOGLE_FS_2246",
      "poi_directions_map_url": "https://maps.google.com/?cid=15757034939766033432",
      "poi_item_slug": "cvs",
      "poi_latitude": "34.8346268",
      "poi_longitude": "-82.35277909999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 864-288-8280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wNt-64vWIgRGEwsGss7rNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_052032ca-faf2-421c-aaf4-82395561ef72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "101 Verdae Blvd, Greenville, SC 29607, USA",
      "poi_short_description": "Chain fitness center supplying strength and cardio machines, plus tanning, and hydromassage.",
      "poi_long_description": "Chain fitness center supplying strength and cardio machines, plus tanning, and hydromassage.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-53bb-730f-96eb-cfbb0911b62a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-53bb-730f-96eb-cfbb0911b62a",
        "storage_key": "property/6767906449167634/019fec29-53bb-730f-96eb-cfbb0911b62a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/greenville-sc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14694936196284874613",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "34.8219113",
      "poi_longitude": "-82.3400206",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 864-627-4008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZ8CwwwvWIgRdf-WCJ3m7ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8b86f953-c90d-4847-9c70-13840848a783",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1143 Woodruff Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Heart-rate-based, full-body group workout combining cardio and strength training with real-time tracking.",
      "poi_long_description": "Heart-rate-based, full-body group workout combining cardio and strength training with real-time tracking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-395c-7368-b73e-55d3d9d7ec49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-395c-7368-b73e-55d3d9d7ec49",
        "storage_key": "property/6767906449167634/019fec2d-395c-7368-b73e-55d3d9d7ec49.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/greenville-south-carolina-0875",
      "poi_directions_map_url": "https://maps.google.com/?cid=792466546159855575",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "34.825491",
      "poi_longitude": "-82.29429069999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 864-697-2660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5deUM4oWIgR1yc9BCBo_wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d1dc3fa7-0767-4517-9e57-ec0d53da4d2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Conestee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 Mauldin Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Family-friendly recreational space featuring ballfields, picnic tables, dog parks and an array of trails.",
      "poi_long_description": "Family-friendly recreational space featuring ballfields, picnic tables, dog parks and an array of trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-665c-7513-b8bd-a34a5be4f870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-665c-7513-b8bd-a34a5be4f870",
        "storage_key": "property/6767906449167634/019fec29-665c-7513-b8bd-a34a5be4f870.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://greenvillerec.com/parks/conestee-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14327331757995132035",
      "poi_item_slug": "conestee-park",
      "poi_latitude": "34.7799888",
      "poi_longitude": "-82.3512721",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 864-387-0265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b3-763b-adad-1e0ade6faada",
        "storage_key": "property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaZFukXQlWIgRgwR5DlPo1MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_880962f4-7886-47ac-8caf-f964c04c9c57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Conestee Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "840 Mauldin Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Home to more than 200 bird species, this 400-acre wildlife preserve offers paved trails & bog walks.",
      "poi_long_description": "Home to more than 200 bird species, this 400-acre wildlife preserve offers paved trails & bog walks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-3567-7767-a175-627ea7defc47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-3567-7767-a175-627ea7defc47",
        "storage_key": "property/6767906449167634/019fec2d-3567-7767-a175-627ea7defc47.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://conesteepreserve.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14514418562035381221",
      "poi_item_slug": "conestee-nature-preserve",
      "poi_latitude": "34.7751711",
      "poi_longitude": "-82.3546277",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 864-277-2004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b3-763b-adad-1e0ade6faada",
        "storage_key": "property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7wiqBUlWIgR5XN0D8iSbck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_485af922-2871-483c-834c-939d59cfa6ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Unity Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "320 S Hudson St, Greenville, SC 29601, USA",
      "poi_short_description": "Playgrounds and swings, plus a climbing wall, for kids of all ages, next to a park with picnic tables.",
      "poi_long_description": "Playgrounds and swings, plus a climbing wall, for kids of all ages, next to a park with picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-59ff-70e2-b5c5-64b37ac2a212.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-59ff-70e2-b5c5-64b37ac2a212",
        "storage_key": "property/6767906449167634/019fec29-59ff-70e2-b5c5-64b37ac2a212.webp",
        "width": 912,
        "height": 511
      },
      "poi_business_url": "https://www.greenvillesc.gov/1843/Unity-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2465477332226762811",
      "poi_item_slug": "unity-park",
      "poi_latitude": "34.8512783",
      "poi_longitude": "-82.411099",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 864-467-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b3-763b-adad-1e0ade6faada",
        "storage_key": "property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeX60tbUxWIgRO2gnLZIiNyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3b3cb257-7034-4e96-92ab-818d48553141",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Swamp Rabbit trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "103 McDaniel Ave, Greenville, SC 29601, USA",
      "poi_short_description": "Clean and well-kept paved trail for biking, running and dog walking, plus a water park.",
      "poi_long_description": "Clean and well-kept paved trail for biking, running and dog walking, plus a water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-3c0a-777f-a5d1-5d964745d4af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-3c0a-777f-a5d1-5d964745d4af",
        "storage_key": "property/6767906449167634/019fec2d-3c0a-777f-a5d1-5d964745d4af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillesc.gov/316/Swamp-Rabbit-Trail",
      "poi_directions_map_url": "https://maps.google.com/?cid=10019634448842541469",
      "poi_item_slug": "swamp-rabbit-trail",
      "poi_latitude": "34.8412489",
      "poi_longitude": "-82.392972",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-63f5-716d-86f0-cb2454d54220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2d-63f5-716d-86f0-cb2454d54220",
        "storage_key": "property/6767906449167634/019fec2d-63f5-716d-86f0-cb2454d54220.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZyrliswWIgRncmG5nHkDIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_83b46e05-7f22-457a-9902-cd5c76196ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Cleveland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Cleveland Park Dr & East Washington, Greenville, SC 29601, USA",
      "poi_short_description": "Venerable urban park on 122 acres with a fitness trail, picnic shelters & tennis/volleyball courts.",
      "poi_long_description": "Venerable urban park on 122 acres with a fitness trail, picnic shelters & tennis/volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-3ff1-7139-833b-4577a534ece6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-3ff1-7139-833b-4577a534ece6",
        "storage_key": "property/6767906449167634/019fec2d-3ff1-7139-833b-4577a534ece6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillesc.gov/1581/Cleveland-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4739581147201544383",
      "poi_item_slug": "cleveland-park",
      "poi_latitude": "34.8493214",
      "poi_longitude": "-82.38468519999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 864-467-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b3-763b-adad-1e0ade6faada",
        "storage_key": "property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz-bRTNUvWIgRvyAWJ_FfxkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2cfe94cd-83f3-40f5-adc6-00b0bb744bf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Greenlink Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 W McBee Ave, Greenville, SC 29601, USA",
      "poi_short_description": "Downtown hub for Greenlink, the City of Greenville's public bus system.",
      "poi_long_description": "Downtown hub for Greenlink, the City of Greenville's public bus system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-3dfd-74c2-8eda-f6e762cf067a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-3dfd-74c2-8eda-f6e762cf067a",
        "storage_key": "property/6767906449167634/019fec2d-3dfd-74c2-8eda-f6e762cf067a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greenvillesc.gov/151/Greenlink-Transit",
      "poi_directions_map_url": "https://maps.google.com/?cid=3801114405955517666",
      "poi_item_slug": "greenlink-transit-center",
      "poi_latitude": "34.8501054",
      "poi_longitude": "-82.4007771",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 864-467-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZ4EoDUwWIgR4jyZvWlFwDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_d0391280-7adc-43b2-a1ef-29746baeddb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Greenville Amtrak Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1120 W Washington St, Greenville, SC 29601, USA",
      "poi_short_description": "Amtrak station on West Washington Street served by the Crescent line between New York, Atlanta and New Orleans.",
      "poi_long_description": "Amtrak station on West Washington Street served by the Crescent line between New York, Atlanta and New Orleans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-6080-73ca-ab22-7de0daf98fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-6080-73ca-ab22-7de0daf98fe7",
        "storage_key": "property/6767906449167634/019fec29-6080-73ca-ab22-7de0daf98fe7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=GRV",
      "poi_directions_map_url": "https://maps.google.com/?cid=12764871577158279811",
      "poi_item_slug": "greenville-amtrak-station",
      "poi_latitude": "34.858508",
      "poi_longitude": "-82.4135993",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-7b0e-72c8-b647-c9a4f5311ddc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-7b0e-72c8-b647-c9a4f5311ddc",
        "storage_key": "property/6767906449167634/019fec29-7b0e-72c8-b647-c9a4f5311ddc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJn7t70bkxWIgRg-L_dxHvJbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_4266cce9-546b-471e-b81c-5d9b47d6e765",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Greenville-Spartanburg International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 GSP Dr, Greer, SC 29651, USA",
      "poi_short_description": "Airport serving the Southeast & offering free WiFI plus conference rooms & snack bars.",
      "poi_long_description": "Airport serving the Southeast & offering free WiFI plus conference rooms & snack bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-4711-77d8-8fb4-3f5123a97253.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-4711-77d8-8fb4-3f5123a97253",
        "storage_key": "property/6767906449167634/019fec2d-4711-77d8-8fb4-3f5123a97253.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.gspairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5592584854167939865",
      "poi_item_slug": "greenville-spartanburg-international-airport",
      "poi_latitude": "34.8959008",
      "poi_longitude": "-82.2172338",
      "poi_miles_from_property": "15.1 mi",
      "poi_walking_minutes": "5 hours 33 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 864-877-7426",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-7af0-7729-8676-b38e6574b469.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-7af0-7729-8676-b38e6574b469",
        "storage_key": "property/6767906449167634/019fec29-7af0-7729-8676-b38e6574b469.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJdfjLOQoqWIgRGevoSEvanE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_fda6f7ba-c10f-4b79-9082-f95e7a11b43d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Clemson University International Center for Automotive Research (CU-ICAR)",
      "poi_type": "Education",
      "poi_address": "5 Research Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Clemson University's automotive research and graduate-engineering campus on Research Drive.",
      "poi_long_description": "Clemson University's automotive research and graduate-engineering campus on Research Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-665f-707a-8c38-a93017d15627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-665f-707a-8c38-a93017d15627",
        "storage_key": "property/6767906449167634/019fec29-665f-707a-8c38-a93017d15627.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://cuicar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3707318036026301668",
      "poi_item_slug": "clemson-university-international-center-for-automotive-research-cu-icar",
      "poi_latitude": "34.8142542",
      "poi_longitude": "-82.327236",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 864-283-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78c9-77e7-8a22-3b8673f1cb20",
        "storage_key": "property/6767906449167634/019fec29-78c9-77e7-8a22-3b8673f1cb20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8FdzGsvWIgR5By_jhwKczM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0354abd2-5724-42b8-9b77-271c13cdeab1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Fluor Enterprises, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Fluor Daniel Dr, Greenville, SC 29607, USA",
      "poi_short_description": "Engineering and construction company with a large Greenville office campus off Fluor Daniel Drive.",
      "poi_long_description": "Engineering and construction company with a large Greenville office campus off Fluor Daniel Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-5505-7299-b6e1-55cab4c1e76a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-5505-7299-b6e1-55cab4c1e76a",
        "storage_key": "property/6767906449167634/019fec2d-5505-7299-b6e1-55cab4c1e76a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fluor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7805122715444489415",
      "poi_item_slug": "fluor-enterprises-inc",
      "poi_latitude": "34.844653",
      "poi_longitude": "-82.334351",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 864-281-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2zSquIuWIgRx6xmosFdUWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_contractor"
    },
    {
      "id": "custom_112b0eed-ab6f-4759-8d4b-6aa30bbb6f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Bon Secours St. Francis Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "1 St Francis Dr, Greenville, SC 29601, USA",
      "poi_short_description": "Acute-care hospital near downtown Greenville, part of the Bon Secours St. Francis Health System.",
      "poi_long_description": "Acute-care hospital near downtown Greenville, part of the Bon Secours St. Francis Health System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-5928-761c-ac69-983b55179aaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-5928-761c-ac69-983b55179aaa",
        "storage_key": "property/6767906449167634/019fec29-5928-761c-ac69-983b55179aaa.webp",
        "width": 864,
        "height": 486
      },
      "poi_business_url": "https://www.bonsecours.com/locations/hospitals-medical-centers/greenville/st-francis-downtown",
      "poi_directions_map_url": "https://maps.google.com/?cid=8958415424688701978",
      "poi_item_slug": "bon-secours-st-francis-downtown",
      "poi_latitude": "34.8403724",
      "poi_longitude": "-82.4214408",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 864-255-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78cd-701b-89d7-dd4b2674b320.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78cd-701b-89d7-dd4b2674b320",
        "storage_key": "property/6767906449167634/019fec29-78cd-701b-89d7-dd4b2674b320.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0Xo5VEwWIgRGkLzcl2vUnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6adfc801-89ad-460b-9927-8a4bfff8c9c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Greenville County Square",
      "poi_type": "Major Employers & Offices",
      "poi_address": "301 University Ridge, Greenville, SC 29601, USA",
      "poi_short_description": "Greenville County government offices on University Ridge.",
      "poi_long_description": "Greenville County government offices on University Ridge.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-5126-7598-9c8e-502fea12606b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-5126-7598-9c8e-502fea12606b",
        "storage_key": "property/6767906449167634/019fec2d-5126-7598-9c8e-502fea12606b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.greenvillecounty.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8519895244608596337",
      "poi_item_slug": "greenville-county-square",
      "poi_latitude": "34.8404824",
      "poi_longitude": "-82.40042550000001",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 864-467-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-64a1-748b-b757-da978297fab2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2d-64a1-748b-b757-da978297fab2",
        "storage_key": "property/6767906449167634/019fec2d-64a1-748b-b757-da978297fab2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUBsRzIwWIgRcWlvqpW_PHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_c9a3ccbd-25d9-4c58-b7ac-7bbf8ee70e67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Michelin North America Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Parkway S, Greenville, SC 29615, USA",
      "poi_short_description": "North American headquarters of the Michelin tire company.",
      "poi_long_description": "North American headquarters of the Michelin tire company.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec2d-5630-7199-be53-ab3cde969da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2d-5630-7199-be53-ab3cde969da2",
        "storage_key": "property/6767906449167634/019fec2d-5630-7199-be53-ab3cde969da2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.michelinman.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1897357148203265553",
      "poi_item_slug": "michelin-north-america-headquarters",
      "poi_latitude": "34.8609544",
      "poi_longitude": "-82.2581886",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 864-458-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdV9YnUpWIgRES60DkbEVBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f5cfa824-30bb-4a8c-af30-50fbf5b42d83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Halls Chophouse Greenville",
      "poi_type": "Restaurants",
      "poi_address": "550 S Main St, Greenville, SC 29601, USA",
      "poi_short_description": "Genteel restaurant with river views, serving Southern fare made with ingredients from nearby farms.",
      "poi_long_description": "Genteel restaurant with river views, serving Southern fare made with ingredients from nearby farms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-43fc-7359-b673-cfe7727755fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-43fc-7359-b673-cfe7727755fd",
        "storage_key": "property/6767906449167634/019fec29-43fc-7359-b673-cfe7727755fd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://hallschophousegvl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2817927810821158282",
      "poi_item_slug": "halls-chophouse-greenville",
      "poi_latitude": "34.8457252",
      "poi_longitude": "-82.4018966",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 864-335-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-dfb7a836c2d6",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-dfb7a836c2d6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMzXT1DIwWIgRinWw9mlKGyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c7f176bd-a48a-4748-958d-45d4ac8e0294",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Haywood Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Haywood Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Sizable mall with shops for clothing, electronics & home goods, plus a range of dining options.",
      "poi_long_description": "Sizable mall with shops for clothing, electronics & home goods, plus a range of dining options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-42e5-765c-bea5-486a69396a55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-42e5-765c-bea5-486a69396a55",
        "storage_key": "property/6767906449167634/019fec29-42e5-765c-bea5-486a69396a55.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.simon.com/mall/haywood-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=5344190777624772756",
      "poi_item_slug": "haywood-mall",
      "poi_latitude": "34.8498312",
      "poi_longitude": "-82.33337759999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 864-288-0511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78cb-7214-8444-057a41630d58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78cb-7214-8444-057a41630d58",
        "storage_key": "property/6767906449167634/019fec29-78cb-7214-8444-057a41630d58.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJXxzrJeUuWIgRlEA-kDJhKko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2caa629d-ff6f-4848-a0c1-59b846ce642d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1140 Woodruff Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-44c4-74fe-b132-851cd6a4e0d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-44c4-74fe-b132-851cd6a4e0d6",
        "storage_key": "property/6767906449167634/019fec29-44c4-74fe-b132-851cd6a4e0d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/greenville",
      "poi_directions_map_url": "https://maps.google.com/?cid=4045313012166723575",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "34.8255774",
      "poi_longitude": "-82.3010094",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 864-335-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-e1e32e3bce5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-e1e32e3bce5f",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-e1e32e3bce5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHa48Q80oWIgR94d2Z8DWIzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_07af865a-598a-4370-888d-0411c9be6986",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "59 Woodruff Industrial Ln, Greenville, SC 29607, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-4859-7403-96fd-e0831d53776a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-4859-7403-96fd-e0831d53776a",
        "storage_key": "property/6767906449167634/019fec29-4859-7403-96fd-e0831d53776a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/sc/greenville/751/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11403048466627304606",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "34.8292498",
      "poi_longitude": "-82.3055042",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 864-286-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a6-715d-bcaf-e1e32e3bce5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a6-715d-bcaf-e1e32e3bce5f",
        "storage_key": "property/6767906449167634/019fec29-78a6-715d-bcaf-e1e32e3bce5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJodNq8i0vWIgRnhziGSrEP54",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ffdb149d-090a-48f0-946a-023095626dad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Bon Secours Wellness Arena",
      "poi_type": "Entertainment",
      "poi_address": "650 N Academy St, Greenville, SC 29601, USA",
      "poi_short_description": "Large indoor arena offering hockey & other sports events plus shows, rock music concerts & more.",
      "poi_long_description": "Large indoor arena offering hockey & other sports events plus shows, rock music concerts & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-4aa2-7785-8c1d-fe647a6a71bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-4aa2-7785-8c1d-fe647a6a71bd",
        "storage_key": "property/6767906449167634/019fec29-4aa2-7785-8c1d-fe647a6a71bd.webp",
        "width": 1024,
        "height": 622
      },
      "poi_business_url": "http://bonsecoursarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12602269140027816876",
      "poi_item_slug": "bon-secours-wellness-arena",
      "poi_latitude": "34.8526077",
      "poi_longitude": "-82.39152519999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 864-241-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJneQ4-dYxWIgRrLs5XwNB5K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d76a4421-c9f8-4e24-a704-5efe4d40ff97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Greenville Zoo",
      "poi_type": "Entertainment",
      "poi_address": "150 Cleveland Park Dr, Greenville, SC 29601, USA",
      "poi_short_description": "A global collection of mammals, reptiles & amphibians is on display at this small, no-frills zoo.",
      "poi_long_description": "A global collection of mammals, reptiles & amphibians is on display at this small, no-frills zoo.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-4b04-745e-a67f-c2bb3ee76743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-4b04-745e-a67f-c2bb3ee76743",
        "storage_key": "property/6767906449167634/019fec29-4b04-745e-a67f-c2bb3ee76743.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.greenvillezoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436227881283834797",
      "poi_item_slug": "greenville-zoo",
      "poi_latitude": "34.8476002",
      "poi_longitude": "-82.3856309",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 864-467-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf6IwACsuWIgRrVM3Vw3vry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_4c89a020-caf3-49c6-9c44-4e0fa785c47e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Oasis Animal Hospital & Emergency Center",
      "poi_type": "Health and Wellness",
      "poi_address": "900 W Butler Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Veterinary hospital with emergency care on West Butler Road.",
      "poi_long_description": "Veterinary hospital with emergency care on West Butler Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-5657-706b-9b58-8b9be40f022e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-5657-706b-9b58-8b9be40f022e",
        "storage_key": "property/6767906449167634/019fec29-5657-706b-9b58-8b9be40f022e.webp",
        "width": 1206,
        "height": 548
      },
      "poi_business_url": "https://www.oasisvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8238678780441048748",
      "poi_item_slug": "oasis-animal-hospital--emergency-center",
      "poi_latitude": "34.776138",
      "poi_longitude": "-82.32737999999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 864-288-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr4QQi-glWIgRrLa8TrOqVXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f55a4682-79d5-478b-8534-c508640ed1fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "Legacy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "336 Rocky Slope Rd, Greenville, SC 29607, USA",
      "poi_short_description": "Park featuring a playground, paved paths, picnic areas, volleyball, water features & more.",
      "poi_long_description": "Park featuring a playground, paved paths, picnic areas, volleyball, water features & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-5efb-7737-ac86-590f73eaf7df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-5efb-7737-ac86-590f73eaf7df",
        "storage_key": "property/6767906449167634/019fec29-5efb-7737-ac86-590f73eaf7df.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.greenvillesc.gov/1580/Legacy-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7409679957939019583",
      "poi_item_slug": "legacy-park",
      "poi_latitude": "34.8293197",
      "poi_longitude": "-82.3324931",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 864-467-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78b3-763b-adad-1e0ade6faada",
        "storage_key": "property/6767906449167634/019fec29-78b3-763b-adad-1e0ade6faada.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxw3djxAvWIgRP19J4Kl41GY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cbd9515e-9a47-4c32-aaca-22a5a427fef4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "custom",
      "poi_name": "JTEKT North America Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7 Research Dr, Greenville, SC 29607, USA",
      "poi_short_description": "North American headquarters of JTEKT, an automotive bearings and steering-systems manufacturer, on Research Drive.",
      "poi_long_description": "North American headquarters of JTEKT, an automotive bearings and steering-systems manufacturer, on Research Drive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-665f-707a-8c38-a93017d15627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec29-665f-707a-8c38-a93017d15627",
        "storage_key": "property/6767906449167634/019fec29-665f-707a-8c38-a93017d15627.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "http://www.jtekt-na.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11165531242613717741",
      "poi_item_slug": "jtekt-north-america-corporation",
      "poi_latitude": "34.8150173",
      "poi_longitude": "-82.327623",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 864-770-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec29-78a4-759e-bded-2bd895597220",
        "storage_key": "property/6767906449167634/019fec29-78a4-759e-bded-2bd895597220.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnRQ4t6IvWIgR7TqE9IHv85o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_bfea6633bc6822777c08a0dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_861b0e1ad616dec9ac73e4e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3e5d5cf3b03de2d709963d7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fe6b68d592270abfa6c57f0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b84f0008518f558bf2868b9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f81ed53b2523231f384a0d1a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "rating": "5",
      "name": "Lars Rascovich",
      "text": "Hi Everyone,\nA couple weeks ago I had to relocate from Anderson, S.C. to Greenville, S.C. for a new job position.\nNeedless to say I had to look at a bunch of townhomes in the area but most of them did not look like the pictures that they presented or they were not well maintained.\nSo I decided to take a look at FairForest CreekSide, Greenville, S.C. and I was greeted by Ashley who was absolutely delight to work with. She answered all my questions and showed me the unit that I was potentially interested in.\nThe following day I met Nicholis and was also welcomed with incredible enthusiasm.\nI look at the unit that I was interested in one more time and I decided to take the leap.\nThese townhomes are absolutely beautiful and so well maintained it blew me away.\nEqually important was the property was also  professionally maintained.\nI met Seth who is the person in charge of maintaining the property and townhomes and he was very accommodating and extremely professional as well.\nI would highly recommend anyone looking for a high quality townhome this should be your destination.\nThank you.\nLars T. Rascovich",
      "date": "2026-06-30",
      "title": "false"
    },
    {
      "id": "ec_a125fc0066cd35bb750655bf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "rating": "5",
      "name": "Jessica Devore",
      "text": "Ashley is the best! She was very helpful and patient with the entire leasing process. I see why there are so many great reviews about her.",
      "date": "2026-05-28",
      "title": "false"
    },
    {
      "id": "ec_32bfb6865d0b5471b4b4cada",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "rating": "5",
      "name": "Ivan Weiss",
      "text": "This property is amazing and I love the floor plans. My focus was getting the most \"bang for my buck\", the most square footage for the dollar, and this property delivers on that. In the end, I decided that a 3 bedroom was more than I needed for just me. However, I was very impressed with this property, what it had for the money and I absolutely loved dealing with Ashley! She is super responsive, very friendly and answers every question. I would definitely recommend this property to others. Maybe it will be where I end up. My experience was a good one. If you are thinking about a place that is close enough to the city but not in the city and gives you a bigger place, with a lot of space, then this property is a great choice.",
      "date": "2024-10-20",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [
    {
      "id": "custom_cb6bfe1f-e368-4004-bd95-9c23d111dd22",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_fc26086d-4d28-411d-840b-d5019261ddd8",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_dad47a1e-28a5-43d9-af6e-ac549c1b8b67",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_69bc569f-8728-4f07-bb43-2bbbfe9d1310",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_985aa06e-d2c8-47f9-b033-655055491577",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_6b0a90bf-8ae4-4844-9f2e-25d713d2f554",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_c86042a3-a782-414a-9b78-ab9993299904",
      "question": "Landscape Services",
      "answer": "Townhomes: $55/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_bf9c3b0c-712c-4717-bb0e-fd2d455350be",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_7400741a-b6dd-4da9-9f35-58bc1b5901b3",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_a72111e1-bd6d-4da4-92ff-9733f3a266d7",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_2c40f117-8dad-4b64-a591-c0675280c2b5",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_19afb453-2620-41be-baff-e4d77c143208",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_14950fc1-3bce-44b7-984a-970be2a92a02",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_f91ad58c-31ea-4144-ae01-92eb6ccec5fd",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_39535fd7-a1c2-4cb5-b15f-5d52c0706d76",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_1a8ff21d-4cff-4dd6-aa26-407c0283a53f",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_66e9f2e6-85ce-4dff-a7a8-1c50fc83b4a1",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_34445b77-24bb-452a-8ae5-e2c3fcc216da",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_96de4321-9b48-4bbf-a9f5-b1da33c328b2",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [
    {
      "id": "ec_a5417f2aed9e9375e7bd8925",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "yardi",
      "external_id": "48e5e1460c920a07",
      "name": "Pet Rent",
      "description": "false",
      "amount": 35,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "false",
      "timing": "false",
      "category": "false",
      "charge_code": "petrent",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": true
    }
  ],
  "pet_policies": [
    {
      "id": "ec_19809f5848a4f87f84a3fccb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "yardi",
      "external_id": "2308675",
      "pet_type": "all",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_943548f3f391ab9e7b232009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "yardi",
      "external_id": "2473182",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_2aff163fa64977bdb2044984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "yardi",
      "external_id": "2473181",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-95ca-74fa-9ac4-7049d209e04a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Fairforest Creekside Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634"
    },
    {
      "lead_collector_id": "01a0abe0-964e-70ac-8e48-33d05deb74c1",
      "lead_source": "LANDING_PAGE",
      "name": "Fairforest Creekside Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-greenville-sc",
      "search_query": "apartments with in-unit laundry Greenville SC",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Looking for apartments with in-unit laundry in Greenville, SC? Discover the convenience awaiting you at Fairforest Creekside.",
      "page_copy": "Discover the ultimate convenience and comfort at Fairforest Creekside. Our apartments with in-unit laundry in Greenville, SC, offer residents a hassle-free living experience. Nestled in a serene setting, our community is crafted for those who value modern living with a touch of luxury. \n\nAt Fairforest Creekside, enjoy lifestyle-enhancing features such as smart-home technology and a fenced backyard, perfect for both relaxation and entertaining. Forget about carrying heavy laundry baskets up and down stairs, and instead, savor the pleasure of fresh, clean clothes at your fingertips. Located in the heart of Greenville, SC, our apartments provide easy access to the vibrant urban amenities while offering a peaceful retreat with everything you need right at home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Greenville, SC",
      "seo_description": "Discover Fairforest Creekside, apartments with in-unit laundry in Greenville, SC, offering comfort and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-greenville-county",
      "search_query": "pet-friendly apartments with dog park Greenville County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Searching for pet-friendly apartments with a dog park in Greenville County? Fairforest Creekside is the perfect place for you and your furry friend.",
      "page_copy": "At Fairforest Creekside, a vibrant pet-friendly community awaits you and your four-legged family members in Greenville County. Our apartments are designed to provide a harmonious lifestyle for both pets and their owners, emphasizing comfort and convenience.\n\nLive happily with amenities like a fenced backyard, perfect for playful afternoons, and our very own dog park, which ensures your pets have a place to exercise and socialize. Besides pet-friendly features, residents enjoy modern conveniences such as in-unit laundry and smart-home technology, enhancing your everyday life. Situated in Greenville County, Fairforest Creekside offers the ideal blend of contemporary living and pet-friendly features, making it a perfect home for everyone.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Discover pet-friendly apartments with a dog park in Greenville County at Fairforest Creekside, offering a happy home for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "luxury-apartments-granite-countertops-29607",
      "search_query": "luxury apartments with granite countertops 29607",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Granite Countertops",
      "h2_subtitle": "Explore luxury apartments with granite countertops in the 29607 area. Fairforest Creekside offers exceptional living in Greenville, SC.",
      "page_copy": "Experience luxury living at its finest with Fairforest Creekside, where our apartments feature exquisite granite countertops, adding a touch of elegance to your everyday life. Positioned in the desirable 29607 area, our community offers a blend of opulence and convenience that is hard to beat.\n\nBesides the stunning granite countertops, residents can indulge in a range of upscale amenities, including smart-home technology, a fenced backyard, and a grill area perfect for entertaining. Our location ensures you're never far from Greenville's vibrant lifestyle while providing a tranquil haven to call home. Choose Fairforest Creekside and enjoy the perfect combination of luxury, style, and accessibility in the heart of the 29607 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Granite Countertops 29607",
      "seo_description": "Explore luxury apartments with granite countertops in the 29607 area at Fairforest Creekside, offering upscale living in Greenville, SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "smart-home-technology-apartments-greenville",
      "search_query": "smart-home technology apartments Greenville",
      "category": "Amenity",
      "h1_title": "Smart-Home Technology Apartments",
      "h2_subtitle": "Discover smart-home technology apartments in Greenville that elevate your living experience. Fairforest Creekside is your perfect modern home.",
      "page_copy": "Upgrade your lifestyle with the smart-home technology offered at Fairforest Creekside, where innovation meets comfort. Situated in the vibrant city of Greenville, our apartments come equipped with the latest smart-home features, providing residents with unmatched convenience and control.\n\nImagine adjusting your home settings with ease or optimizing energy efficiency with just a few taps. Beyond smart-home technology, our community includes other desirable amenities such as in-unit laundry, a fenced backyard, and a grill area. Located in the heart of Greenville, Fairforest Creekside is ideal for those seeking a future-forward lifestyle paired with comfort and leisure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Technology Apartments in Greenville",
      "seo_description": "Explore smart-home technology apartments in Greenville at Fairforest Creekside, perfect for modern and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-greenville-sc",
      "search_query": "apartments with stainless steel appliances Greenville SC",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Find apartments with stainless steel appliances in Greenville, SC. Fairforest Creekside offers stylish and modern living in a prime location.",
      "page_copy": "At Fairforest Creekside, our apartments in Greenville, SC, are equipped with premium stainless steel appliances, bringing a sleek and modern touch to your culinary experiences. These high-quality appliances complement the sophisticated interior design, offering functionality and style.\n\nIn addition to stainless steel appliances, our community features numerous amenities such as smart-home technology, in-unit laundry, and a fenced backyard. Located in Greenville, our apartments provide easy access to local attractions and conveniences, making them an ideal choice for contemporary living. Experience the blend of style, comfort, and convenience at Fairforest Creekside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel Appliances Greenville",
      "seo_description": "Discover apartments with stainless steel appliances in Greenville, SC at Fairforest Creekside, offering modern and stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-greenville-county",
      "search_query": "three bedroom apartments greenville county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Greenville County",
      "h2_subtitle": "Explore spacious three bedroom apartments in Greenville County at Fairforest Creekside, ideal for families and roommates alike.",
      "page_copy": "Fairforest Creekside offers spacious three bedroom apartments located in the heart of Greenville County, perfect for families or roommates seeking extra room. Our thoughtfully designed floor plans provide comfort and style, ensuring every resident enjoys a cozy living environment.\n\nInside our three bedroom homes, you'll find smart-home technology and convenient in-unit laundry facilities. Residents also have access to a fenced backyard, a grill area for social gatherings, and a security deposit alternative, enhancing the overall living experience. Reside at Fairforest Creekside and experience the best of Greenville County with easy access to local amenities and entertainment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Greenville County",
      "seo_description": "Discover spacious three bedroom apartments in Greenville County at Fairforest Creekside, perfect for families or roommates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "3-bedroom-floorplans-greenville-sc",
      "search_query": "3 bedroom floorplans greenville sc",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Floorplans in Greenville, SC",
      "h2_subtitle": "Discover versatile 3 bedroom floorplans in Greenville, SC at Fairforest Creekside. Perfect for varied lifestyles and family needs.",
      "page_copy": "Fairforest Creekside presents versatile 3 bedroom floorplans designed to meet diverse living needs in Greenville, SC. Our spacious apartments are perfect for families, professionals, or anyone who values indoor space and modern conveniences.\n\nEach apartment features smart-home technology, in-unit laundry, and a fenced backyard, making them well-equipped for today's lifestyles. Community amenities such as a grill area and security deposit alternative further enhance the convenience of living here. Conveniently located, our Greenville apartments ensure you're never far from the vibrant city life while enjoying a serene living environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Floorplans in Greenville, SC",
      "seo_description": "Explore versatile 3 bedroom floorplans in Greenville, SC at Fairforest Creekside, offering modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "spacious-three-bedroom-apts-near-29607",
      "search_query": "spacious three bedroom apts near 29607",
      "category": "Floorplan",
      "h1_title": "Spacious Three Bedroom Apts Near 29607",
      "h2_subtitle": "Discover spacious three bedroom apts near 29607 at Fairforest Creekside. Ideal for families seeking comfort and convenience.",
      "page_copy": "Located near the 29607 area, Fairforest Creekside offers spacious three bedroom apartments designed for modern living. These large units provide ample space for families, ensuring every member can enjoy personal comfort and privacy.\n\nOur apartments come complete with smart-home technology and in-unit laundry facilities. The community also boasts amenities like a fenced backyard, a grill area for socializing, and a security deposit alternative to simplify your move. Come explore the harmonious blend of function and style at our apartments near 29607, offering access to local conveniences and entertainment in Greenville, SC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Three Bedroom Apts Near 29607",
      "seo_description": "Find spacious three bedroom apts near 29607 at Fairforest Creekside, offering ample room and modern amenities in Greenville, SC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "apartments-near-bob-jones-university-greenville-sc",
      "search_query": "apartments near Bob Jones University Greenville SC",
      "category": "School",
      "h1_title": "Apartments Near Bob Jones University, Greenville SC",
      "h2_subtitle": "Find the perfect home at Fairforest Creekside, just minutes from Bob Jones University in Greenville, SC, ideal for students and faculty alike.",
      "page_copy": "Situated conveniently near Bob Jones University, Fairforest Creekside offers comfortable living options ideal for students and faculty in Greenville, SC. Our community provides easy access to the university while offering a quiet retreat from campus life.\n\nChoose from our variety of apartments equipped with smart-home technology, in-unit laundry, and a fenced backyard for added privacy. Additional amenities include a grill area and a security deposit alternative, making it an attractive choice for those needing a seamless transition to off-campus living. Experience the perfect balance of convenience and relaxation at Fairforest Creekside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bob Jones University, Greenville SC",
      "seo_description": "Discover apartments near Bob Jones University, Greenville SC at Fairforest Creekside, perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "apartments-close-to-greenville-technical-college-29607",
      "search_query": "apartments close to Greenville Technical College 29607",
      "category": "School",
      "h1_title": "Apartments Close to Greenville Tech College 29607",
      "h2_subtitle": "Explore comfortable living options at Fairforest Creekside, strategically located close to Greenville Technical College in the 29607 area.",
      "page_copy": "Fairforest Creekside offers a convenient and modern lifestyle for those seeking apartments close to Greenville Technical College in the 29607 area. Our location is perfect for students and faculty who prefer to live near campus while enjoying a vibrant community.\n\nAt Fairforest Creekside, you'll find contemporary amenities such as smart-home technology and in-unit laundry. Our community also features a fenced backyard, grill area, and a security deposit alternative, ensuring a comfortable and practical living experience. Discover the convenience and comfort of living near Greenville Technical College at Fairforest Creekside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Greenville Tech College 29607",
      "seo_description": "Find convenient apartments near Greenville Technical College in the 29607 area at Fairforest Creekside, ideal for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "apartments-near-bon-secours-st-francis-downtown-greenville",
      "search_query": "apartments near Bon Secours St. Francis Downtown Greenville",
      "category": "Hospital",
      "h1_title": "Apartments Near Bon Secours St. Francis Downtown",
      "h2_subtitle": "Discover convenient living at Fairforest Creekside, just a short drive from Bon Secours St. Francis Downtown in Greenville.",
      "page_copy": "Fairforest Creekside presents an ideal living solution for those seeking apartments near Bon Secours St. Francis Downtown Greenville. Our location provides quick access to healthcare professionals and employees working at the hospital, making daily commutes seamless.\n\nOur community offers contemporary amenities like smart-home technology and in-unit laundry, ensuring a hassle-free lifestyle. Residents can also enjoy a fenced backyard, a communal grill area, and the advantage of a security deposit alternative. Experience the blend of comfortable and convenient living at Fairforest Creekside, where proximity to the heart of Greenville's medical facilities meets modern apartment features.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Bon Secours St. Francis Downtown",
      "seo_description": "Find apartments close to Bon Secours St. Francis Downtown Greenville at Fairforest Creekside. Ideal for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "apartments-near-unity-park-greenville-sc",
      "search_query": "apartments near unity park greenville sc",
      "category": "Park",
      "h1_title": "Apartments Near Unity Park, Greenville SC",
      "h2_subtitle": "Live close to the vibrant Unity Park in Greenville, SC by choosing Fairforest Creekside as your new home.",
      "page_copy": "Fairforest Creekside is the perfect choice for those looking for apartments near Unity Park in Greenville, SC. Enjoy the blend of urban living with the tranquility of our community, all while being just moments from one of the city's most vibrant recreational areas.\n\nOur apartments offer modern conveniences including smart-home technology, in-unit laundry, and private fenced backyards. Make use of our grill area for social gatherings and take advantage of our security deposit alternative for easy move-ins. At Fairforest Creekside, experience the best of Greenville with Unity Park practically at your doorstep.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Unity Park, Greenville SC",
      "seo_description": "Discover modern apartments near Unity Park in Greenville, SC at Fairforest Creekside. Enjoy convenience and comfort just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "apartments-close-to-falls-park-on-the-reedy-greenville-county",
      "search_query": "apartments close to falls park on the reedy greenville county",
      "category": "Park",
      "h1_title": "Apts Close to Falls Park on the Reedy, Greenville",
      "h2_subtitle": "Choose Fairforest Creekside and enjoy living close to Falls Park on the Reedy in beautiful Greenville County.",
      "page_copy": "For those seeking the perfect blend of tranquility and convenience, Fairforest Creekside offers exceptional apartments close to Falls Park on the Reedy in Greenville County. Experience natural beauty paired with modern living amenities that make life effortless and enjoyable.\n\nResidents at Fairforest Creekside benefit from innovative smart-home technology, hassle-free in-unit laundry, and the privacy of a fenced backyard. Our community also features a welcoming grill area and offers a security deposit alternative, making moving easier than ever. Embrace the serene charm and accessibility of Greenville County by choosing Fairforest Creekside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Falls Park on the Reedy, Greenville",
      "seo_description": "Enjoy modern living at Fairforest Creekside with apartments near Falls Park on the Reedy, located in scenic Greenville County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "multifamily-near-conestee-park-29607",
      "search_query": "multifamily near conestee park 29607",
      "category": "Park",
      "h1_title": "Multifamily Living Near Conestee Park",
      "h2_subtitle": "Explore Fairforest Creekside for multifamily options near Conestee Park in the 29607 area.",
      "page_copy": "Fairforest Creekside offers exceptional multifamily living near Conestee Park in the vibrant 29607 area. Our community provides residents with both contemporary comforts and the charm of Greenville's natural landscape.\n\nEnjoy the integration of smart-home technology, in-unit laundry facilities, and the luxury of a fenced backyard. Our residents are also welcomed to utilize the grill area and benefit from our security deposit alternative. Positioned conveniently near Conestee Park, Fairforest Creekside combines serene living with easy access to outdoor adventures.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Multifamily Apts Near Conestee Park 29607",
      "seo_description": "Fairforest Creekside offers multifamily living near Conestee Park in the 29607 area, providing modern amenities and natural charm.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167634",
      "source": "generator",
      "page_item_url": "apartments-by-legacy-park-greenville",
      "search_query": "apartments by legacy park in greenville",
      "category": "Park",
      "h1_title": "Apartments by Legacy Park, Greenville",
      "h2_subtitle": "Discover Fairforest Creekside, located conveniently close to Legacy Park in the heart of Greenville.",
      "page_copy": "If you're searching for apartments by Legacy Park in Greenville, Fairforest Creekside is your ideal destination. Our community perfectly combines modern living with proximity to one of Greenville's beloved green spaces.\n\nResidents enjoy top-tier amenities like smart-home technology and in-unit laundry. A fenced backyard offers added privacy, while the grill area is perfect for socializing. Plus, our security deposit alternative simplifies the move-in process. With Legacy Park just a short distance away, Fairforest Creekside offers the best of both convenience and comfort in Greenville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by Legacy Park in Greenville",
      "seo_description": "Find comfort and convenience at Fairforest Creekside with apartments located close to Legacy Park in Greenville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977263359"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5ZSD8BGZ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57147875950"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8ywko136vlx"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/7ae755c9-de17-42b5-80c5-7c2aa9f247f9/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f5765cd0-ff93-11ef-9462-8fb2e999234f"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-967-4381"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "866-753-7051"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977263359",
  "custom_google_gtm_id": "GTM-5ZSD8BGZ",
  "custom_rollout_phase": "Phase 1",
  "custom_ads_subscription": "full_stack",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57147875950",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8ywko136vlx",
  "custom_self_guided_tour_url": "https://selftournow.com/property/7ae755c9-de17-42b5-80c5-7c2aa9f247f9/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f5765cd0-ff93-11ef-9462-8fb2e999234f",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "844-967-4381",
  "custom_paid_social_tracking_phone_number": "866-753-7051",
  "custom_audioeye_site_id": "0b6d0d29-315c-40f9-8e6e-ade856976f11",
  "custom_audioeye_site_hash": "116320a11d211773252534fe3183dbba"
};

export const generatedAt = '2026-10-29T18:34:10.394Z';
